import { getAssetsByLevels, getAssetsSummaryCards } from "@/api/financialReport";
import { createBalanceLevelReport } from "./createBalanceLevelReport";

// Tab Activos: saldo acumulado del nivel-1 "Activos". La lógica vive en el factory
// (compartida con Pasivos/Patrimonio); acá sólo se inyecta el endpoint y labels.
export default createBalanceLevelReport({
    fetchBreakdown: getAssetsByLevels,
    fetchSummary: getAssetsSummaryCards,
    totalLabel: "Activos",
    ratioLabel: "Activos / Ventas (%)",
    errorLabel: "Error al cargar activos.",
    summaryErrorLabel: "Error al cargar resumen de activos.",
    logPrefix: "[assetsReport]",
});
